import { Table } from 'react-dsgov';
import styles from './operacaoDetalhes.module.scss';
import { formatCurrency } from '../../../../../../utils/formatCurrency';
import { IOperacaoResumo } from '../../../../../../interfaces/IOperacaoPLG';
import { formatPLGTipoOperacao } from '../../../../../../utils/formatPLGTipoOperacao';
import { formatarCNPJOrCpf } from '../../../../../../utils/formatCNPJOrCPF';

interface IHeader {
  field: string;
  label: string;
  format?: Function;
}

interface IFooter {
  value: string;
  colspan?: number;
}

interface IProps {
  data: IOperacaoResumo;
}

function OperacaoDetalhes({ data }: IProps) {
  const TABELA_FIRST_ROW: IHeader[] = [
    {
      field: data.cpfCnpj || '-',
      label: 'CPF/CNPJ',
      format: formatarCNPJOrCpf,
    },
    {
      field: formatPLGTipoOperacao(data.tipo),
      label: 'Tipo da Operação',
    },
  ];

  const TABELA_CABECALHO: IHeader[] = [
    {
      field: '',
      label: 'Dados da Operação',
    },
    {
      field: 'id',
      label: 'Código do Item',
    },
    { field: 'codigoNcm', label: 'Código NCM' },
    { field: 'quantidade', label: 'Quantidade', format: formataQuantidade },
    {
      field: 'valorUnitario',
      label: 'Preço Unitário',
      format: formatCurrency,
    },
    {
      field: 'valorTotal',
      label: 'Valor da Operação',
      format: formatCurrency,
    },
    {
      field: 'isRejeito',
      label: 'Rejeitos/Estéreis',
      format: formataBoolean,
    },
  ];

  const TABELA_RODAPE: IFooter[] = [
    { value: 'Total R$', colspan: 3 },
    { value: formataQuantidade(data.totalQuantidade) },
    { value: '' },
    { value: formatCurrency(data?.totalValorOperacao) },
    { value: '' },
  ];

  function formataBoolean(valor: boolean) {
    return valor ? 'Sim' : 'Não';
  }

  function formataQuantidade(valor: number) {
    if (valor) {
      return valor.toLocaleString('pt-br');
    }

    return '';
  }

  return (
    <div className={styles.secao}>
      <div className={styles.tabela}>
        <Table
          showTopBar={false}
          headers={TABELA_CABECALHO}
          showPagination={false}
          showDensityButtons={false}
          showSearch={false}
          density='medium'
          tabIndex={0}
        >
          <tbody>
            {data.itensOperacao.length !== 0 ? (
              data.itensOperacao.map((row: any, index: any) => (
                <tr key={index} data-testid='linha-dados'>
                  {index === 0 && (
                    <th
                      className={`border-right ${styles.infoRow}`}
                      rowSpan={data.itensOperacao.length}
                      scope='rowgroup'
                    >
                      <div className={styles.firstRow}>
                        {TABELA_FIRST_ROW.map((value, index) => (
                          <div className={styles.firstRowContent} key={index}>
                            <span>{value.label}:</span>
                            <p>{value.format ? value.format(value.field) : value.field}</p>
                          </div>
                        ))}
                      </div>
                    </th>
                  )}
                  {TABELA_CABECALHO.map((header, index) => (
                    <>
                      {index !== 0 && (
                        <td key={header.field} className={styles.tableCell}>
                          {header.format ? header.format(row[header.field]) : (row[header.field] ?? '')}
                        </td>
                      )}
                    </>
                  ))}
                </tr>
              ))
            ) : (
              <tr data-testid='sem-operacao'>
                {' '}
                <th className={`border-right`} rowSpan={1} scope='rowgroup'>
                  <div className={styles.firstRow}>
                    {TABELA_FIRST_ROW.map((value, index) => (
                      <div className={styles.firstRowContent} key={index}>
                        <span>{value.label}:</span>
                        <p>{value.field}</p>
                      </div>
                    ))}
                  </div>
                </th>
                <td colSpan={TABELA_CABECALHO.length} className={styles.noOperacoes}>
                  Não há operações cadastradas
                </td>
              </tr>
            )}
          </tbody>

          <tfoot className={styles.tableFooter}>
            <tr data-testid='linha-rodape'>
              {TABELA_RODAPE.map((footer, index) => (
                <td key={index} colSpan={footer.colspan ?? 1}>
                  {footer.value}
                </td>
              ))}
            </tr>
          </tfoot>
        </Table>
      </div>
    </div>
  );
}

export default OperacaoDetalhes;
